import Echo from "laravel-echo";
import Pusher from "pusher-js";
import axios from "axios";

window.Pusher = Pusher;

let echoInstance = null;

/**
 * getEcho — ab authToken parameter sirf "kya user logged in hai" check
 * karne ke liye use hota hai. Actual channel authorization har baar
 * localStorage se FRESH token khud utha leta hai (authorizer ke zariye),
 * is liye background refresh (authRefresh.js) ke baad bhi Pusher
 * connection kabhi purane/invalid token se stuck nahi hoga.
 */
export const getEcho = (baseUrl, authToken) => {
  if (!authToken) return null;

  // Ek hi Echo instance poori session mein kaafi hai — token change
  // hone par recreate karne ki zaroorat nahi, kyunke authorizer
  // har dafa khud latest token localStorage se le leta hai.
  if (echoInstance) {
    return echoInstance;
  }

  echoInstance = new Echo({
    broadcaster: "pusher",
    // .env file bana kar us ma paste karna hai key + cluster ka jo pusher ki website se milega
    // Aur comment out karna hai niche wala key + cluster ka jo yaha likha hai
    // key: process.env.REACT_APP_PUSHER_KEY,
    // cluster: process.env.REACT_APP_PUSHER_CLUSTER,

    key: "6c987b64a68747e3c8a3",
    cluster: "ap2",

    forceTLS: true,

    // ── Dynamic authorizer: har channel subscribe/re-subscribe par
    // localStorage se abhi ka authToken uthata hai, static header ki
    // tarah ek dafa fix nahi hota ──
    authorizer: (channel) => {
      return {
        authorize: (socketId, callback) => {
          const freshToken = localStorage.getItem("authToken");

          axios
            .post(
              `${baseUrl}/broadcasting/authenticate`,
              {
                socket_id: socketId,
                channel_name: channel.name,
              },
              {
                headers: {
                  Authorization: `Bearer ${freshToken}`,
                },
              },
            )
            .then((response) => {
              callback(false, response.data);
            })
            .catch((error) => {
              callback(true, error);
            });
        },
      };
    },
  });

  return echoInstance;
};

export const disconnectEcho = () => {
  if (echoInstance) {
    echoInstance.disconnect();
    echoInstance = null;
  }
};

export default getEcho;
